import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

import InsurancePromptStep, {
	IInsurancePromptStepPageContent,
} from './InsurancePromptStep.component';

interface IInsurancePromptStepPageProps extends IFlowStepProps {}

const InsurancePromptStepPage: FC<IInsurancePromptStepPageProps> = ({ path, stepKey }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "insurance-prompt-step" }) {
				page_header
				insurance_label
				insurance_description
				other_label
				other_description
				government_label
				government_description
			}
		}
	`);

	const { existingFormData, handleFormSubmission, handleNavBack } = useContext(FlowContext);

	const refinedContent: IInsurancePromptStepPageContent = keysToCamel(
		pageContent
	) as IInsurancePromptStepPageContent;

	return (
		<InsurancePromptStep
			pageContent={refinedContent}
			path={path}
			stepKey={stepKey}
			existingFormData={existingFormData}
			handleFormSubmission={handleFormSubmission}
			handleNavBack={handleNavBack}
		/>
	);
};

export default InsurancePromptStepPage;
